import { getEmployerBankAccounts, getFormattedDate } from "../../../../../../legacyComponents/util/helperFunctions"
import { options } from "../util"

export default function getInitialValues(props) {
	const { employer } = props

	const { billingAccount, reimbursementAccount } = getEmployerBankAccounts(employer)
	const billingMethods = options.billingMethods(reimbursementAccount)

	const invoiceMethod = employer?.employerAccount?.invoiceMethod
	const stripeId = employer?.employerAccount?.invoiceAccountId
	const stripeAccount = employer?.subscriptions?.find((stripe) => stripe?.stripeSubscriptionId === stripeId) || {}
	const stripeDetails = stripeAccount?.stripeSubscription?.paymentMethod

	return {
		name: "",

		billingMethod: (() => {
			let billingMethod = null
			// console.log("In Flow_Billing: getInitialValues, invoiceMethod = ", invoiceMethod);
			// console.log("In Flow_Billing: getInitialValues, billingAccount = ", billingAccount);
			if (invoiceMethod === "STRIPE") {
				billingMethod = "STRIPE"
			} else if (billingAccount?.id === reimbursementAccount?.id) {
				billingMethod = "REIMBURSEMENT"
			} else if (invoiceMethod === "BILLING") {
				billingMethod = "BILLING"
			// } else {
			// 	billingMethod = "BILLING"
			}

			billingMethod = billingMethods.find(({ value }) => value === billingMethod)
			// console.log("In Flow_Billing: getInitialValues, returning billingMethod = ", billingMethod);
			return billingMethod || options.nullOption()
		})(),

		bank: (() => {
			if (billingAccount?.id) {
				const { routingNumber, nickname } = billingAccount
				return { ...billingAccount, displayName: `${routingNumber || "000000000"} - ${nickname}` }
			} else {
				return options.nullBankOption()
			}
		})(),

		bankName: billingAccount?.bankName,
		nickname: billingAccount?.nickname,
		accountType: billingAccount?.accountType,
		accountNumber: billingAccount?.accountNumber,

		stripeBrand: (() => {
			let brand = stripeDetails?.brand

			if (brand?.length > 0) {
				brand = brand.charAt(0).toUpperCase() + brand.slice(1)
			}

			return brand
		})(),

		stripeNumber: (() => {
			let cardNumber = stripeDetails?.last4

			if (cardNumber?.length > 0) {
				cardNumber = `**** **** **** ${cardNumber}`
			}

			return cardNumber
		})(),

		stripeExpiration: (() => {
			let expirationDate = ""

			if (stripeDetails) {
				const { expMonth, expYear } = stripeDetails

				if (expMonth && expYear) {
					expirationDate = getFormattedDate({
						date: new Date(expYear, expMonth - 1),
						options: { month: "long", year: "numeric" }
					})
				}
			}

			return expirationDate
		})()
	}
}
